module.exports = __webpack_public_path__ + "img/1582049033.bbe1f008.jpg";